import React, { Dispatch, SetStateAction } from "react";
import styles from "./listPagination.module.css";
import { TLimits } from "../../types/types";
import i18n from "../../i18n";
import { tWithKeyAttr as t } from "../../i18nHelper";

interface IListPaginationProps {
  limits: TLimits;
  total: number;
  step: number;
  setLimits: Dispatch<SetStateAction<TLimits>> | Dispatch<SetStateAction<{ FakeComapnyId: number | string, limit: TLimits }[] | undefined>>;
  groupKey?: number | string;
}
function ListPagination({
  limits,
  total,
  setLimits,
  step,
  groupKey
}: IListPaginationProps) {
  const onNextClick = () => {
    if (limits.end < total) {
      if (!groupKey) {
        (setLimits as Dispatch<SetStateAction<TLimits>>)((prev) => ({
          ...prev,
          start: prev.start + step,
          end: prev.end + step < total ? prev.end + step : total,
        }));
      }
      else {
        (setLimits as Dispatch<SetStateAction<{ FakeComapnyId: number | string, limit: TLimits }[]>>)(
          (prev) => {
            return prev.map(li => {
              if ((groupKey == null && li.FakeComapnyId === "null") || (li.FakeComapnyId === groupKey)) {
                return {
                  ...li,
                  limit: {
                    start: li.limit.start + step,
                    end: li.limit.end + step < total ? li.limit.end + step : total
                  }
                }
              }
              else {
                return li
              }
            })
          })
      };
    }
  }
  const onPrevClick = () => {
    if (limits.start > 1) {
      if (!groupKey) {
        (setLimits as Dispatch<SetStateAction<TLimits>>)((prev) => ({
          ...prev,
          start: prev.start - step,
          end: prev.start - 1,
        }));
      }
      else {
        (setLimits as Dispatch<SetStateAction<{ FakeComapnyId: number | string, limit: TLimits }[]>>)(
          (prev) => {
            return prev.map(li => {
              if ((groupKey == null && li.FakeComapnyId === "null") || (li.FakeComapnyId === groupKey)) {
                return {
                  ...li,
                  limit: {
                    start: li.limit.start - step,
                    end: li.limit.start - 1
                  }
                }
              }
              else {
                return li
              }
            })
          })
      };
    }
  };
  return (
    <article className={styles.pagination} dir={i18n.dir()}>
      <div className={`${styles.btn_forward_backward_container} ${styles.btn_forward_container}`}>
        <button
          className={`${styles.btn} ${styles.btn_forward}`}
          onClick={onPrevClick}
        /></div>
       <div>
        {t('PAGINATION_MESSAGE', {
          start: limits.start,
          end: limits.end < total ? limits.end : total,
          total,
        })}
        </div>
      <div className={`${styles.btn_forward_backward_container} ${styles.btn_backward_container}`}>
        <button
          className={`${styles.btn} ${styles.btn_backward}`}
          onClick={onNextClick}
        />
      </div>
    </article>
  );
}

export default ListPagination;
